/* tslint:disable */

/**
 */
export class ChangePassword {
    oldPass?: string;
    newPass?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/change-password.ts